import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/useAuthStore';
import { LoadingSpinner } from './LoadingSpinner';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, sessionToken, identifier, validateSession } = useAuthStore();
  const [isValidating, setIsValidating] = useState(false);

  useEffect(() => {
    const validateExistingSession = async () => {
      if (!isAuthenticated && sessionToken && identifier) {
        setIsValidating(true);
        await validateSession(identifier);
        setIsValidating(false);
      }
    };

    validateExistingSession();
  }, [isAuthenticated, sessionToken, identifier, validateSession]);

  if (isValidating) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <LoadingSpinner message="Validando sesión..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    // Solo redirigir a error si no hay datos de sesión almacenados
    if (!sessionToken) {
      // Si tenemos identifier pero no sessionToken, asumimos sesión expirada/cerrada
      if (identifier) {
        return <Navigate to="/session-closed" replace />;
      }
      // Si no tenemos ni token ni identifier, redirigir a login
      return <Navigate to="/login" replace />;
    }
    return null; // Esperar a que la validación termine
  }

  return <>{children}</>;
}